import routerOptions0 from "/vercel/path0/nuxt/node_modules/.pnpm/nuxt@3.13.0_@parcel+watcher@2.4.1_@types+node@22.5.1_@vercel+kv@1.0.1_encoding@0.1.13_eslint@_53ry7ul7eosd7wglgzbnswff44/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}